import * as Updates from 'expo-updates';
import React, { useState } from 'react';

import { Divider, Header } from '@fhs-legacy/universal-components';
import useEffectOnce from 'hooks/use-effect-once';
import { getDeviceId } from 'utils/device-id';
import { getCurrentCommitHash } from 'utils/environment';
import { getUserContext } from 'utils/launchdarkly/client';

import { EnvItem, Inner } from './components';
import { InternalDiagnostics } from './internal-diagnostics';

async function fetchDeviceIdAndLaunchDarklyContext() {
  const [deviceIdResult, ldContext] = await Promise.all([getDeviceId(), getUserContext()]);
  return {
    deviceId: deviceIdResult || '',
    ldAppVersion: ldContext.appVersion ?? '',
    ldAppShellVersion: ldContext.appShellVersion ?? '',
  };
}

export const Configs = () => {
  const [deviceId, setDeviceId] = useState<string>('');
  const [ldAppVersion, setLdAppVersion] = useState<string>('');
  const [ldAppShellVersion, setLdAppShellVersion] = useState<string>('');

  useEffectOnce(() => {
    void fetchDeviceIdAndLaunchDarklyContext().then(data => {
      setDeviceId(data.deviceId);
      setLdAppVersion(data.ldAppVersion);
      setLdAppShellVersion(data.ldAppShellVersion);
    });
  });

  return (
    <Inner>
      <Divider />
      <Header pt={4} variant="headerFour">
        Device Information
      </Header>
      <EnvItem envKey="Device Id" value={deviceId} />

      <Divider />

      <Header pt={4} variant="headerFour">
        EAS Update (Over The Air Updates)
      </Header>
      <EnvItem envKey="Runtime Version" value={Updates.runtimeVersion} />
      <EnvItem envKey="LD context appVersion" value={ldAppVersion} />
      <EnvItem envKey="LD context appShellVersion" value={ldAppShellVersion} />
      <EnvItem envKey="Build Commit Hash" value={getCurrentCommitHash()} />
      <EnvItem envKey="Update Id" value={Updates.updateId} />
      <EnvItem envKey="Update Channel" value={Updates.channel} />
      <Divider />

      <InternalDiagnostics />
    </Inner>
  );
};
